// 基础的主动上报信息
export enum LogLevel {
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    INFO = 'INFO',
    DEBUG = 'DEBUG',
}

export interface IPadding {		// 附加信息是任意 json 结构的数据
    [key: string]: any;
}

export default interface ILog {
    name: string;				// 错误名
    content: string;			// 日志内容
    level: LogLevel;			// 日志级别
    padding?: IPadding;			// 附加信息
    resourceUrl?: string;		// 资源 url
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/core/types/log.type.ts